export class UserRequest {
  codigo: string;
  nombre: string;
  mail: string;
  tipoUsuario: string;
  cuenta: string;
  tarjetaId?: number;
  funcionalidades: string[];

  constructor(data: {
    codigo: string;
    nombre: string;
    mail: string;
    tipoUsuario: string;
    cuenta: string;
    funcionalidades: string[];
    tarjetaId?: number;
  }) {
    this.codigo = data.codigo;
    this.nombre = data.nombre;
    this.mail = data.mail;
    this.tipoUsuario = data.tipoUsuario;
    this.cuenta = data.cuenta;
    this.tarjetaId = data.tarjetaId;
    this.funcionalidades = data.funcionalidades;
  }
}
